export const PATH = {
	HOME: '/',
	LOGIN: '/login',
	SIGNUP: '/sign-up',
	LOST_PASS: '/lost-password',
	ABOUT: '/about',
	PRODUCT: '/product',
	CATEGORY: '/category',
	CHECKOUT: '/checkout',
	PAGE404: '/404',
};
